import EmployeeRewardsPlatforms from "../../components/best/EmployeeRewardsPlatforms";

export { Page }

function Page() {
  return <EmployeeRewardsPlatforms />;
}